export default __webpack_public_path__ + "static/media/sounds/TRO_Start_Reading_Page_Backup.mp3";